import { FC, ReactNode } from 'react'
import { useTrackVisibility } from 'react-intersection-observer-hook'

type Props = {
  children: (state: { isSticky: boolean }) => ReactNode
  topOffset?: number
}

const Sticky: FC<Props> = ({ children, topOffset = 0 }) => {
  // A sentinel above the element. We're stuck once it scrolls past the top
  // offset — distinguished from "below the fold" by its rect, not just
  // visibility. entry is undefined until the observer fires, so isSticky stays
  // false through SSR and the first client render.
  const [ref, { entry }] = useTrackVisibility({
    rootMargin: `-${topOffset}px 0px 0px 0px`,
  })

  const isSticky = entry
    ? !entry.isIntersecting && entry.boundingClientRect.top < topOffset
    : false

  return (
    <>
      <div ref={ref} aria-hidden style={{ height: 1, marginBottom: -1 }} />
      {children({ isSticky })}
    </>
  )
}

export default Sticky
